/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1PersonIdContactData200,
  GetApiV1PersonIdContactData401,
  GetApiV1PersonIdContactData404,
  GetApiV1PersonIdContactData500,
  GetApiV1PersonIdContactDataPathParams,
  GetApiV1PersonIdContactDataQueryResponse,
} from "../../types/personRegisterController/GetApiV1PersonIdContactData.ts";
import { personContactDataViewModelSchema } from "../personContactDataViewModelSchema.ts";

export const getApiV1PersonIdContactDataPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<GetApiV1PersonIdContactDataPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1PersonIdContactData200Schema = z.lazy(
  () => personContactDataViewModelSchema,
) as unknown as ToZod<GetApiV1PersonIdContactData200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1PersonIdContactData401Schema =
  z.any() as unknown as ToZod<GetApiV1PersonIdContactData401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1PersonIdContactData404Schema =
  z.any() as unknown as ToZod<GetApiV1PersonIdContactData404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1PersonIdContactData500Schema =
  z.any() as unknown as ToZod<GetApiV1PersonIdContactData500>;

export const getApiV1PersonIdContactDataQueryResponseSchema = z.lazy(
  () => getApiV1PersonIdContactData200Schema,
) as unknown as ToZod<GetApiV1PersonIdContactDataQueryResponse>;
